import { useEffect, useState } from 'react';
import { loadSkill } from '../../application/models/loadSkill';

import CTA from '../../infrastructure/components/CTA';
import Footer from '../../infrastructure/components/Footer';
import { Container, Stack } from '@chakra-ui/layout';
import { Box } from '@chakra-ui/react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from "@chakra-ui/react";
import { Text, Divider } from '@chakra-ui/react';
import Title from '../components/Title';
import Explanation from '../components/Explanation';
import WarmUp from '../components/WarmUp';
import Skill from '../components/Skill';
import Test from '../components/Test';

const SkillPage = ({ match }) =>
{
    const id = match.url.replace('/', '');
    const [language, setLanguage] = useState('es');
    const [isLoading, setIsLoading] = useState(true);
    const [skill, setSkill] = useState([]);
    useEffect(() => {
        async function fetchSkill () {
            const json = await loadSkill(id);
            setSkill(json[language]);
            setIsLoading(false);
        }
        fetchSkill();
    }, [id, language]);

    if (isLoading) return null;
    return (
        <>
        <Title title={skill.title} subtitle={skill.subtitle} image={id} />
        <Explanation explanation={skill.explanation} />
        <Divider />
        <Container py="40px" maxW="4xl">
            <Breadcrumb fontWeight="medium" fontSize="sm" mb="20px">
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">
                            <Text as="u">Skills</Text>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                        <Text>{skill.name}</Text>
                    </BreadcrumbItem>
            </Breadcrumb>
            <Accordion defaultIndex={0} allowToggle>
            {
                skill.days.map(day =>
                    <AccordionItem key={day.id}>
                        <h2>
                        <AccordionButton _expanded={{ bg: "#00E5FF", color: "white" }}>
                            <Box flex="1" textAlign="left" fontFamily="Museo Sans Bold">
                            DAY {day.id}
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                        <Stack direction="row">
                            <Stack spacing={3} py="20px">
                            <WarmUp movements={day.warmup} />
                            {
                                day.test
                                ? <Test test={day.test.name} link={day.test.link} />
                                : null
                            }
                            <Skill movements={day.skills} />
                            </Stack>
                        </Stack>
                        </AccordionPanel>
                    </AccordionItem>
                )
            }
            </Accordion>
        </Container>
        <CTA />
        <Footer />
        </>
    );
};

export default SkillPage;